import { logEvent } from './logGaEvent'

const removeSpaceAndLowercase = (str) => {
  return str.toLowerCase().replace(/ /g, '_')
}

const getLogParams = ({ filterName, filterType, filterItem, enabledFlag }) => ({
  product_name: 'air',
  page_name: 'listings',
  filter_name: filterName,
  filter_type: filterType || '',
  filter_item: filterItem || '',
  enabled_flag: enabledFlag || '',
})

// GA4
const logFilterEvent = (filterParams) => {
  const attributes = getLogParams(filterParams)
  logEvent('filter', attributes)
}

// done
const logStopsFilter = ({ numStops, isDynamic = false, enabled }) => {
  const stopsCount = numStops == '0' ? 'non_stop' : numStops == '1' ? '1_stop' : '2_stops'
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'stops',
    filterType: isDynamic ? 'dynamic' : 'static',
    filterItem: stopsCount,
    enabledFlag: enabled ? 'y' : 'n',
  })
}

const logDurationFilter = ({ duration = '', isDynamic = false }) => {
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'duration',
    filterType: isDynamic ? 'dynamic' : 'static',
    filterItem: duration, // e.g. '12h35m'
  })
}

// done
const logAirportFilter = ({ airport, isOnly, isDynamic = false, enabled }) => {
  const airportName = airport.toLowerCase()
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'airports',
    filterType: isOnly ? 'only' : isDynamic ? 'dynamic' : 'static',
    filterItem: airportName,
    enabledFlag: enabled ? 'y' : 'n',
  })
}

// done
const logAirlinesFilter = ({ airlineCode, isOnly, isDynamic = false, enabled }) => {
  const airline = airlineCode.toLowerCase()
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'airlines',
    filterType: isOnly ? 'only' : isDynamic ? 'dynamic' : 'static',
    filterItem: airline,
    enabledFlag: enabled ? 'y' : 'n',
  })
}

//done
const logAttributesFilter = ({ attribute, isDynamic = false, enabled }) => {
  const attributeLogValues = {
    CARRY_ON: 'carry-on bag',
    SEATS: 'seats',
    CHANGES: 'changes',
  }
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'attribute',
    filterType: isDynamic ? 'dynamic' : `static`,
    filterItem: attributeLogValues[attribute],
    enabledFlag: enabled ? 'y' : 'n',
  })
}

const logTimeChipFilter = ({ type, label, isDynamic = false, enabled }) => {
  logFilterEvent({
    filterName: isDynamic ? 'chip' : removeSpaceAndLowercase(`time filter ${type}`), // takeoff/landing
    filterType: isDynamic ? 'dynamic' : `static`,
    filterItem: removeSpaceAndLowercase(label), // 'early_morning', 'morning', etc.
    enabledFlag: enabled ? 'y' : 'n',
  })
}

export {
  logStopsFilter,
  logDurationFilter,
  logAirportFilter,
  logAirlinesFilter,
  logAttributesFilter,
  logTimeChipFilter,
}
